import { BrandScreen } from 'app/features/brands/screens'
import { dedupeBrandOfferIds } from 'app/features/brands/screens/brand-screen/lib/dedupe-brand-offer-ids'
import { fetchBrandQuery } from 'app/features/brands/screens/brand-screen/queries'
import { fetchBrandOffersQuery } from 'app/features/brands/screens/brand-screen/queries/use-brand-offers.query'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <BrandScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, params, query }) => {
  const user = req?.session?.user
  const slug = params?.brand
  const draft = !!query?.preview

  const client = initializeApollo({
    token: user?.token,
    previewToken: query?.token as string,
  })

  const brandData = await client.query({
    query: fetchBrandQuery.query,
    variables: {
      slug,
      draft,
    },
  })

  const brandId = brandData?.data?.Brands?.docs?.[0]?.id || ''
  const dedupeIds = dedupeBrandOfferIds(brandData?.data)

  if (!brandId) {
    return {
      notFound: true,
    }
  }

  await client.query({
    query: fetchBrandOffersQuery.query,
    variables: {
      brand: brandId,
      dedupeIds,
      page: 1,
      limit: 6,
    },
  })

  return addApolloState(client, {
    props: {
      user: user || null,
      draft,
    },
  })
})
